"use client";
/**
 * 管理画面（admin）専用の MUI テーマ。
 * @repo/common のベースを継承し、パレット（スカンジナビア調・視認性重視）とコンテナ等の上書きを定義する。
 */
import { createTheme } from "@mui/material/styles";
import baseTheme from "@repo/common/config/muiTheme";

const theme = createTheme({
  ...baseTheme,
  cssVariables: true,
  palette: {
    ...baseTheme.palette,
    primary: {
      main: "#355A5C",
      light: "#4F7578",
      dark: "#243D3F",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#6B5344",
      light: "#8A7260",
      dark: "#4F3D32",
      contrastText: "#ffffff",
    },
    danger: {
      main: "#A14040",
      light: "#C16868",
      dark: "#7A2F2F",
      contrastText: "#ffffff",
    },
    background: {
      default: "#F5F3EF",
      paper: "#ffffff",
    },
  },
  typography: {
    ...baseTheme.typography,
  },
  components: {
    ...baseTheme.components,
    MuiContainer: {
      ...baseTheme.components?.MuiContainer,
      styleOverrides: {
        ...baseTheme.components?.MuiContainer?.styleOverrides,
        root: {
          // && で詳細度を上げて確実に適用（cssVariables やデフォルトに負けない）
          "&&": {
            marginLeft: 1,
          },
        },
      },
    },
  },
});

export default theme;
